import React, { useState, memo } from 'react';
import { useTranslation } from 'react-i18next';
import PrimaryButton from '@components/PrimaryButton';
import ChangeOrderStatusModal from '../../../ChangeOrderStatusModal';
import CustomCheckbox from '../CustomCheckbox';
import { useStyles, useStylesButton } from './styles';

const OrderItemCard = ({
  status,
  isChecked,
  isRefunded,
  orderItemData,
  isRunnerTypeUser,
  isTipChecked,
  changeOrderGroupStatus,
  updateCheckedOrderItem,
}) => {
  const classes = useStyles();
  const classesButton = useStylesButton();
  const { t } = useTranslation('pointOfService');

  const { id, productName, productPrice, statusOrderItem } = orderItemData;
  const [isOpenModal, setOpenModal] = useState(false);

  const handleModalShow = isOpen => () => {
    setOpenModal(isOpen);
  };

  const defineCardStyle = ({ checked, refunded }) => {
    if (checked) {
      return {
        borderColor: '#FF9B07',
      };
    }

    if (refunded) {
      return {
        backgroundColor: '#303C50',
        borderColor: '#303C50',
      };
    }

    return {
      borderColor: '#171C2C',
      backgroundColor: '#171C2C',
    };
  };

  const defineProductNameStyle = refunded => ({
    color: refunded ? '#78879A' : '#FFFFFF',
  });

  const defineProductPriceStyle = refunded => ({
    color: refunded ? '#FF9B07' : '#BECDE0',
  });

  const cardStyle = defineCardStyle({
    checked: isChecked || isTipChecked,
    refunded: statusOrderItem === 'refunded' || isRefunded,
  });

  const productNameStyle = defineProductNameStyle(
    statusOrderItem === 'refunded' || isRefunded,
  );

  const productPriceStyle = defineProductPriceStyle(
    statusOrderItem === 'refunded' || isRefunded,
  );

  const isTip = orderItemData?.payment?.tipAmount;

  return (
    <>
      <div className={classes.orderItem} style={cardStyle}>
        <div className={classes.orderCheck}>
          {!isRunnerTypeUser && (
            <CustomCheckbox
              isDisabled={statusOrderItem === 'refunded' || isRefunded}
              isChecked={isChecked || isTipChecked}
              setChecked={updateCheckedOrderItem({ id, productPrice, isTip })}
            />
          )}
          <div className={classes.productNamePrice}>
            <p className={classes.productName} style={productNameStyle}>
              {isTip ? 'TIPS' : productName}
            </p>
            {!isTip ? (
              <p className={classes.productPrice} style={productPriceStyle}>
                {statusOrderItem === 'refunded' || isRefunded
                  ? t('productRefunded')
                  : `${new Intl.NumberFormat('nl-NL', {
                      style: 'currency',
                      currency: 'EUR',
                    }).format(productPrice)}`}
              </p>
            ) : (
              <p className={classes.productPrice} style={productPriceStyle}>
                {statusOrderItem === 'refunded' || isRefunded
                  ? t('productRefunded')
                  : `${new Intl.NumberFormat('nl-NL', {
                      style: 'currency',
                      currency: 'EUR',
                    }).format(isTip)}`}
              </p>
            )}
          </div>
        </div>
        {!isTip && (
          <PrimaryButton
            text={status}
            classesButton={classesButton}
            handleClick={handleModalShow(true)}
          />
        )}
      </div>
      <ChangeOrderStatusModal
        open={isOpenModal}
        handleClose={handleModalShow}
        currentStatus={status}
        serviceItemsIds={[orderItemData.id]}
        changeOrderGroupStatus={changeOrderGroupStatus}
        typeCountUpdate="single"
      />
    </>
  );
};

export default memo(
  OrderItemCard,
  (prevProps, nextProps) => prevProps.isChecked === nextProps.isChecked,
);
